// ======================header-desktop start===================
document.addEventListener("DOMContentLoaded", function () {
  // Handle COLLECTIONS menu
  const collectionsMenuItem = document.querySelector(
    'li[data-item-title="COLLECTIONS"]'
  );
  if (collectionsMenuItem) {
    const pcMenu = collectionsMenuItem.querySelector(".pc-menu");
    if (pcMenu) {
      collectionsMenuItem.addEventListener("mouseenter", () => {
        pcMenu.style.display = "block";
      });

      collectionsMenuItem.addEventListener("mouseleave", () => {
        pcMenu.style.display = "none";
      });
    }
  }

  // Handle GIFT GUIDE menu
  const giftGuideMenuItem = document.querySelector(
    'li[data-item-title="GIFT GUIDE"]'
  );
  if (giftGuideMenuItem) {
    const pcMenuGift = document.querySelector(".pc-menu-giftrr");
    const subMegaGi = document.getElementById("sub_mega_gi");

    if (pcMenuGift && subMegaGi) {
      // Append sub menu if not already appended
      if (!giftGuideMenuItem.contains(subMegaGi)) {
        giftGuideMenuItem.appendChild(subMegaGi);
      }

      giftGuideMenuItem.addEventListener("mouseenter", () => {
        pcMenuGift.style.display = "block";
      });

      giftGuideMenuItem.addEventListener("mouseleave", () => {
        pcMenuGift.style.display = "none";
      });
    }
  }

  // Handle PRODUCT CATEGORY menu visibility
  const productCategoryMenuItem = document.querySelector(
    'li[data-item-title="PRODUCT CATEGORY"]'
  );
  if (productCategoryMenuItem) {
    function updateMenuItemVisibility() {
      if (window.innerWidth >= 768) {
        productCategoryMenuItem.classList.add("hide-desktop");
        productCategoryMenuItem.classList.remove("hide-mobile");
      } else {
        productCategoryMenuItem.classList.add("hide-mobile");
        productCategoryMenuItem.classList.remove("hide-desktop");
      }
    }

    // Initial visibility check
    updateMenuItemVisibility();

    // Update visibility on window resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      // Debounce resize event
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateMenuItemVisibility, 250);
    });
  }
});

// Color effect functions for menu items
function gold_color_effect1() {
  resetActiveItems();
  document.querySelector(".ex-online .tablinks").classList.add("pcc-active");
  showMenuContent("HeaderMenu-collections-online");
}

function gold_color_effect2() {
  resetActiveItems();
  document.querySelector(".bridal-sub .tablinks").classList.add("pcc-active");
  showMenuContent("HeaderMenu-collections-bridal");
}

// Helper functions
function resetActiveItems() {
  document.querySelectorAll(".pcc-active").forEach((item) => {
    item.classList.remove("pcc-active");
  });
}

function showMenuContent(id) {
  // Hide all menu contents
  document.querySelectorAll(".column.subcat").forEach((content) => {
    content.style.display = "none";
  });

  // Show selected content
  const selectedContent = document.getElementById(id);
  if (selectedContent) {
    selectedContent.style.display = "block";
  }
}

// Gift menu functions
function showMom() {
  resetGiftActiveItems();
  document.querySelector(".mom-dsk").classList.add("pcc-active-gift");
  showGiftMenuContent("HeaderMenu-collections-online-gift");
}

function showDad() {
  resetGiftActiveItems();
  document.querySelector(".dad-dsk").classList.add("pcc-active-gift");
  showGiftMenuContent("HeaderMenu-collections-bridal-gift");
}

function resetGiftActiveItems() {
  document.querySelectorAll(".pcc-active-gift").forEach((item) => {
    item.classList.remove("pcc-active-gift");
  });
}

function showGiftMenuContent(id) {
  document
    .querySelectorAll(".pc-contents .column.subcat")
    .forEach((content) => {
      content.style.display = "none";
    });

  const selectedContent = document.getElementById(id);
  if (selectedContent) {
    selectedContent.style.display = "block";
  }
}

// ======================header-desktop end===================
// ======================header-mobile start===================

document.addEventListener("DOMContentLoaded", function () {
  child_anchor_ele = document.getElementsByClassName("element_op_clo");

  const secondChild1 = document.querySelector(
    "ul.menu_links > li:nth-child(2)"
  );
  const thirdChild1 = document.querySelector("ul.menu_links > li:nth-child(3)");
  const fourthChild1 = document.querySelector(
    "ul.menu_links > li:nth-child(4)"
  );
  const fifthChild = document.querySelector("ul.menu_links > li:nth-child(5)");
  const seventhChild = document.querySelector(
    "ul.menu_links > li:nth-child(8)"
  );

  const collectionElement = document.getElementById("pc-menu--mob-id");
  const productElement = document.getElementById("pc-menu--mob-id-products");
  const giftElement = document.getElementById("pc-menu--mob-id-gift-guide");
  const promotionsElement = document.getElementById(
    "pc-menu--mob-id-promotions"
  );
  const pccElement = document.getElementById("pc-menu--mob-id-legacy");

  const collectionElementopen = document.getElementById("arrow_mob1_open");
  const collectionElementoclose = document.getElementById("arrow_mob1_close");
  const productElementopen = document.getElementById("arrow_mob2_open");
  const productElementclose = document.getElementById("arrow_mob2_close");
  const promotionsElementopen = document.getElementById("arrow_mob3_open");
  const promotionsElementclose = document.getElementById("arrow_mob3_close");
  const giftElementopen = document.getElementById("arrow_mob4_open");
  const giftElementclose = document.getElementById("arrow_mob4_close");

  productElement.style.display = "block";
  productElementopen.style.display = "block";
  productElementclose.style.display = "none";
  child_anchor_ele[0].style.color = "#F00";

  if (secondChild1) secondChild1.appendChild(productElement);
  if (thirdChild1) thirdChild1.appendChild(collectionElement);
  if (fourthChild1) fourthChild1.appendChild(promotionsElement);
  if (fifthChild) fifthChild.appendChild(giftElement);
  if (seventhChild) seventhChild.appendChild(pccElement);

  if (secondChild1) {
    secondChild1.addEventListener("click", function () {
      collectionElement.style.display = "none";
      productElement.style.display = "block";
      giftElement.style.display = "none";
      promotionsElement.style.display = "none";
      pccElement.style.display = "none";

      collectionElementopen.style.display = "none";
      collectionElementoclose.style.display = "block";
      productElementopen.style.display = "block";
      productElementclose.style.display = "none";
      promotionsElementopen.style.display = "none";
      promotionsElementclose.style.display = "block";
      giftElementopen.style.display = "none";
      giftElementclose.style.display = "block";

      child_anchor_ele[0].style.color = "#F00";
      child_anchor_ele[1].style.color = "";
      child_anchor_ele[2].style.color = "";
      child_anchor_ele[3].style.color = "";
      child_anchor_ele[4].style.color = "";
    });
  }

  if (thirdChild1) {
    thirdChild1.addEventListener("click", function () {
      collectionElement.style.display = "block";
      productElement.style.display = "none";
      giftElement.style.display = "none";
      promotionsElement.style.display = "none";
      pccElement.style.display = "none";

      collectionElementopen.style.display = "block";
      collectionElementoclose.style.display = "none";
      productElementopen.style.display = "none";
      productElementclose.style.display = "block";
      promotionsElementopen.style.display = "none";
      promotionsElementclose.style.display = "block";
      giftElementopen.style.display = "none";
      giftElementclose.style.display = "block";

      child_anchor_ele[0].style.color = "";
      child_anchor_ele[1].style.color = "#F00";
      child_anchor_ele[2].style.color = "";
      child_anchor_ele[3].style.color = "";
      child_anchor_ele[4].style.color = "";
    });
  }

  if (fourthChild1) {
    fourthChild1.addEventListener("click", function () {
      collectionElement.style.display = "none";
      productElement.style.display = "none";
      giftElement.style.display = "none";
      promotionsElement.style.display = "block";
      pccElement.style.display = "none";

      collectionElementopen.style.display = "none";
      collectionElementoclose.style.display = "block";
      productElementopen.style.display = "none";
      productElementclose.style.display = "block";
      promotionsElementopen.style.display = "block";
      promotionsElementclose.style.display = "none";
      giftElementopen.style.display = "none";
      giftElementclose.style.display = "block";

      child_anchor_ele[0].style.color = "";
      child_anchor_ele[1].style.color = "";
      child_anchor_ele[2].style.color = "#F00";
      child_anchor_ele[3].style.color = "";
      child_anchor_ele[4].style.color = "";
    });
  }

  if (fifthChild) {
    fifthChild.addEventListener("click", function () {
      collectionElement.style.display = "none";
      productElement.style.display = "none";
      giftElement.style.display = "block";
      promotionsElement.style.display = "none";
      pccElement.style.display = "none";
      promotionsElement.style.top = "55px";

      collectionElementopen.style.display = "none";
      collectionElementoclose.style.display = "block";
      productElementopen.style.display = "none";
      productElementclose.style.display = "block";
      promotionsElementopen.style.display = "none";
      promotionsElementclose.style.display = "block";
      giftElementopen.style.display = "block";
      giftElementclose.style.display = "none";

      child_anchor_ele[0].style.color = "";
      child_anchor_ele[1].style.color = "";
      child_anchor_ele[2].style.color = "";
      child_anchor_ele[3].style.color = "#F00";
      child_anchor_ele[4].style.color = "";
    });
  }

  if (seventhChild) {
    seventhChild.addEventListener("click", function () {
      collectionElement.style.display = "none";
      productElement.style.display = "none";
      giftElement.style.display = "none";
      promotionsElement.style.display = "none";
      pccElement.style.display = "block";

      collectionElementopen.style.display = "none";
      collectionElementoclose.style.display = "block";
      productElementopen.style.display = "none";
      productElementclose.style.display = "block";
      promotionsElementopen.style.display = "none";
      promotionsElementclose.style.display = "block";
      giftElementopen.style.display = "none";
      giftElementclose.style.display = "block";

      child_anchor_ele[0].style.color = "";
      child_anchor_ele[1].style.color = "";
      child_anchor_ele[2].style.color = "";
      child_anchor_ele[3].style.color = "";
      child_anchor_ele[4].style.color = "#F00";
    });
  }
});

window.onload = showMugdhaa1();
function clearActive12() {
  const tabs12 = document.querySelectorAll(".tablinks1");
  tabs12.forEach((tab22) => {
    tab22.classList.remove("pcc-activeR");
  });
}
function showOnline1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.online1")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}

function showBridal1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.bridal1")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function qwertfaq() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.earing1223")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}

function showLites1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.pendant")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}

function showMugdhaa1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.mugdha")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}

function showEterknight1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.earring")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function qwertqqft4() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.jewellery1142")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "block";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function qwertqqft4552() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.mangalsutra1142")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "block";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function showLittle1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.coin")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function showSilver() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.silver")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "block";
}

function qwert() {
  showOnline1();
}
function qwert1() {
  showBridal1();
}
function qwert2() {
  showLites1();
}
function qwert3() {
  showMugdhaa1();
}

function qwert4() {
  showEterknight1();
}
function qwert5() {
  showLittle1();
}
function qwert6() {
  showSilver();
}

function clearActive1() {
  const tabs = document.querySelectorAll(".mtablinks");
  tabs.forEach((tab) => {
    tab.classList.remove("pcc-active-m");
    // if (!tab.classList.contains('rihis-mobile')) {
    //      tab.innerHTML = '';
    //  }
  });
}
function showOnline_mobcol() {
  clearActive1();
  document.querySelector(".online-mobile").classList.add("pcc-active-m");
  // document.querySelector('.online-mobile').innerHTML = 'EXCLUSIVELY ONLINE';
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}

function showBridal_mobcol() {
  clearActive1();
  document.querySelector(".bridal-mobile").classList.add("pcc-active-m");
  // document.querySelector('.bridal-mobile').innerHTML = 'WEDDING';
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}

function showLites_mobcol() {
  clearActive1();
  document.querySelector(".lites-mobile").classList.add("pcc-active-m");
  // document.querySelector('.lites-mobile').innerHTML = 'PCC LITES';
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}

function showMugdhaa_mobcol() {
  clearActive1();
  document.querySelector(".mugdhaa-mobile").classList.add("pcc-active-m");
  // document.querySelector('.mugdhaa-mobile').innerHTML = 'MUGDHAA';
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "block";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}

function showEterknight_mobcol() {
  clearActive1();
  document.querySelector(".eter-mobile").classList.add("pcc-active-m");
  // document.querySelector('.eter-mobile').innerHTML = 'ETERKNIGHT';
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "block";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}
function showLittle_mobcol() {
  clearActive1();
  document.querySelector(".little-mobile").classList.add("pcc-active-m");
  // document.querySelector('.little-mobile').innerHTML = 'LITTLE JEWELS';
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}
function showRihi_mobcol() {
  clearActive1();
  document.querySelector(".rihis-mobile").classList.add("pcc-active-m");
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}
function showGcoin_mobcol() {
  console.log("texting");
  clearActive1();
  document.querySelector(".gcb-mobile").classList.add("pcc-active-m");
  // document.querySelector('.gcb-mobile').innerHTML = 'Astrology & Consultation';
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "block";
}

function gold_color_effect1_mcol() {
  showOnline_mobcol();
}

function gold_color_effect2_mcol() {
  showBridal_mobcol();
}

function gold_color_effect3_mcol() {
  showLites_mobcol();
}

function gold_color_effect4_mcol() {
  showMugdhaa_mobcol();
}

function gold_color_effect5_mcol() {
  showEterknight_mobcol();
}
function gold_color_effect6_mcol() {
  showLittle_mobcol();
}
function gold_color_effect7_mcol() {
  showRihi_mobcol();
}
function gold_color_effect8_mcol() {
  showGcoin_mobcol();
}

window.onload = showOnline_mobcol();

function clearActive23() {
  const tabs1 = document.querySelectorAll(".tablinks-guidemob");
  tabs1.forEach((tab2) => {
    tab2.classList.remove("pcc-active-mkt");
  });
}

function showOnline_mobcol_gift() {
  clearActive23();
  document
    .querySelector(".online-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
  // document.getElementById("HeaderMenu-collections-gcoin-mcol-gif").style.display = "none";
}

function showBridal_mobcol_gif() {
  clearActive23();
  document
    .querySelector(".bridal-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
  // document.getElementById("HeaderMenu-collections-gcoin-mcol-gif").style.display = "none";
}

function showLites_mobcol_gif() {
  clearActive23();
  document
    .querySelector(".lites-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
  // document.getElementById("HeaderMenu-collections-gcoin-mcol-gif").style.display = "none";
}

function showMugdhaa_mobcol_gif() {
  clearActive23();
  document
    .querySelector(".mugdhaa-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
  // document.getElementById("HeaderMenu-collections-gcoin-mcol-gif").style.display = "none";
}

function showEterknight_mobcol_gif() {
  clearActive23();
  document
    .querySelector(".eter-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
  // document.getElementById("HeaderMenu-collections-gcoin-mcol-gif").style.display = "none";
}
function showLittle_mobcol_gif() {
  clearActive23();
  document
    .querySelector(".little-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
  // document.getElementById("HeaderMenu-collections-gcoin-mcol-gif").style.display = "none";
}
function showLittle_mobcol_gif12() {
  clearActive23();
  document
    .querySelector(".rihis-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "block";
  // document.getElementById("HeaderMenu-collections-gcoin-mcol-gif").style.display = "none";
}

function gold_color_effect1_mcol_gif() {
  showOnline_mobcol_gift();
}

function gold_color_effect2_mcol_gif() {
  showBridal_mobcol_gif();
}

function gold_color_effect3_mcol_gif() {
  showLites_mobcol_gif();
}

function gold_color_effect4_mcol_gif() {
  showMugdhaa_mobcol_gif();
}

function gold_color_effect5_mcol_gif() {
  showEterknight_mobcol_gif();
}
function gold_color_effect6_mcol_gif() {
  showLittle_mobcol_gif();
}
function gold_color_effect7_mcol_gif() {
  showLittle_mobcol_gif12();
}
// function gold_color_effect8_mcol_gif() {
//     showLittle_mobcol_gif22();
//   }

window.onload = showOnline_mobcol_gift();

// Handle hover event
document.querySelectorAll(".hover_store_cs").forEach((item) => {
  item.addEventListener("mouseenter", function () {
    // Use 'mouseenter' for hover behavior
    // Reset color for all items
    document.querySelectorAll(".hover_store_cs").forEach((el) => {
      el.style.color = ""; // Reset color
    });
    // Set red color for the hovered item
    this.style.color = "red";
  });
});

// Handle click event
document.querySelectorAll(".hover_store_cs").forEach((item) => {
  item.addEventListener("click", function () {
    // Reset color for all items
    document.querySelectorAll(".hover_store_cs").forEach((el) => {
      el.style.color = ""; // Reset color
    });
    // Set red color for the clicked item
    this.style.color = "red";

    // Reset color for specific arrow elements
    document.querySelectorAll(".arrow_mob1_open")[0].style.color = "black";
    document.getElementById("arrow_mob2_open").style.color = "black";
    document.getElementById("arrow_mob3_open").style.color = "black";
    document.getElementById("arrow_mob4_open").style.color = "black";

    // Reset color for elements with class 'element_op_clo'
    document.querySelectorAll(".element_op_clo").forEach((el) => {
      el.style.color = ""; // Reset color
    });
  });
});
function clearActive1212() {
  const tabs123 = document.querySelectorAll(".tablinks12");
  tabs123.forEach((tab221) => {
    tab221.classList.remove("pcc-active-mkt");
  });
}
function gold_color_effect_pramotion1() {
  clearActive1212();
  document
    .querySelector(".tablinks12.for-mobile12.online-mobile12")
    .classList.add("pcc-active-mkt");
  let pramotion1 = document.getElementById(
    "HeaderMenu-collections-online-pramotion_container1"
  );
  let pramotion2 = document.getElementById(
    "HeaderMenu-collections-bridal-pramotion_container2"
  );
  pramotion1.style.display = "block";
  // pramotion2.style.display = "none";
}
function gold_color_effect_pramotion2() {
  clearActive1212();
  document
    .querySelector(".tablinks12.for-mobile12.bridal-mobile12")
    .classList.add("pcc-active-mkt");
  let pramotion1 = document.getElementById(
    "HeaderMenu-collections-online-pramotion_container1"
  );
  let pramotion2 = document.getElementById(
    "HeaderMenu-collections-bridal-pramotion_container2"
  );
  pramotion1.style.display = "none";
  pramotion2.style.display = "block";
}
window.onload = gold_color_effect_pramotion1();

// ======================header-mobile end===================
